import React, { useCallback } from "react";
import { useAppDispatch } from "../../../../../../redux/hooks";
import { VerifyCommandProductsListInterface } from "../../../../../../redux/interfaces/avizPicking.interface";
import { setVerifyCommandProductsList } from "../../../../../../redux/reducer/avizPicking.reducer";

import { QrCodeObjectInterface } from "../../../../../../helpers/qrCodeFormater";

import ProductCardComponent from "./ProductCardComponent";

function VerifyCommandTable({
  verifyCommandProductsList,
  verificationZone,
  qrCodeParams,
  handleFocusProductScannedInput,
}: {
  verifyCommandProductsList: VerifyCommandProductsListInterface[];
  verificationZone: string;
  qrCodeParams: QrCodeObjectInterface | null;
  handleFocusProductScannedInput: () => void;
}) {
  const dispatch = useAppDispatch();

  const handleValidateProduct = useCallback(
    (
      product: VerifyCommandProductsListInterface,
      withScanProductAutoFocus?: boolean,
    ) => {
      const newCommandProducts = verifyCommandProductsList.map(
        (commandProduct) => {
          if (commandProduct.idPozitiePicking === product.idPozitiePicking) {
            return {
              ...commandProduct,
              isValidate: !commandProduct.isValidate,
            };
          }
          return commandProduct;
        },
      );
      dispatch(setVerifyCommandProductsList(newCommandProducts));
      if (withScanProductAutoFocus) {
        handleFocusProductScannedInput();
      }
    },
    [dispatch, handleFocusProductScannedInput, verifyCommandProductsList],
  );

  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full min-w-[1050px] border-collapse align-middle [&_th]:px-3 [&_th]:py-3 [&_th]:text-left [&_td]:px-3 [&_td]:py-4">
        <thead>
          <tr className="font-semibold text-muted-dark bg-surface-subtle">
            <th className="rounded-l-control">Valid</th>
            <th>Nume</th>
            <th>Cantitate</th>
            <th>Lot</th>
            <th>Data expirare</th>
            <th>Bax</th>
            <th>Celula</th>
            <th className="w-[180px] rounded-r-control"></th>
          </tr>
        </thead>
        <tbody>
          {verifyCommandProductsList?.map((product) => (
            <ProductCardComponent
              key={product.idPozitiePicking}
              commandCode={verificationZone}
              product={product}
              qrCodeParams={qrCodeParams}
              handleValidateProduct={handleValidateProduct}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default VerifyCommandTable;
